<template>
 <div class="com-bottom side-panel top mapBg osy" style="left:25%;">
    <div class="side-panel-bg p-20 mb-20">
      <div class="side-panel-content ">
        <div class="fr ov comCenterIndex">
          <div class="sabgicon1">
            <div>{{problemCount.energy_use}}</div>
            <p>能源使用问题</p>
          </div>
          <div class="sabgicon1">
            <div>{{problemCount.computing_power_usage}}</div>
            <p class="moreyc">算力使用不合规问题</p>
          </div>
          <div class="sabgicon1">
            <div>{{problemCount.network_security}}</div>
            <p>网络安全问题</p>
          </div>
          <div class="sabgicon1">
            <div>{{problemCount.information_security}}</div>
            <p>信息安全问题</p>
          </div>
        </div>
      </div>
    </div>
    <div style="width:852px;height:495px; margin: -40px auto 0;"><img src="/imgs/compliancecenterbg.png"></div>
    <div class="side-panel-bg p-20">
      <div id="publishMain" class="centerNews">
        <div id="publishMain1">
          <div class="centerNewsCon" v-for='(news , index) in eventList' :key ='index'>
            <div
              class="centerNewsContitle f-12 pt-5"
              :style="{ color: colors[index % colors.length] }"
            >
              {{news.data}} {{news.title}}</div>
            <div class="f-14 ellipsisBox"> {{news.content}}</div>
            <div class="blikunnewsicon">处置</div>
          </div>
        </div>
        <div id="publishMain2"></div>
      </div>
    </div>

 </div>
</template>

<script>

export default {
  name: "VideoDetail",
  components: {
  },
   props: {
    resData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      problemCount:{},
      eventList:{},

      colors: ['#A9FF99', '#DF9BFF', '#FFF5C3'],// 颜色列表
    };
  },
  created() {
    //获取视频地址
    // this.request("/file/detail/" + id).then(res => {
    //    this.playerOptions.sources[0].src = res.data.url
    // })
  },
  mounted () {
    this.$nextTick(function () {
      // 初始化dom相关数据
      setTimeout(()=>{
        this.problemCount = this.resData.problemCount
        this.eventList = this.resData.eventList
      },300)
    })
  },
}
</script>
<style scoped>
.side-panel-bg{
  background: rgba(0,0,0,0) !important;
}
.comCenterIndex{
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;
}

.sabgicon1{
  background: url(/imgs/compliancecentericon.png) no-repeat center;
  width: 124px;
  height: 98px;
  margin-right: 78px;
}
.sabgicon1:last-child{
  margin-right:0px;
}
.sabgicon1 div{
  text-align: center;
  font-size: 36px;
  color: #39DDFF;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}
.sabgicon1 p{
  text-align: center;
  font-size: 16px;
  color: #95D8E6;
  letter-spacing: 0;
  font-weight: 400;
  margin-top: 80px;

}
.sabgicon1 p.moreyc{
  width: 240px;
  text-align: left;
}
.sabgicon2{
  background: url(/imgs/sabg_bg2.png) no-repeat center;
  height: 158px;
}

.c-bgyanse1{
  color: #00ECFF;
}
.newsList{
  padding-right: 0;
}
.centerNews{
  width:100%;
  height:270px;
  overflow-y: scroll;
  margin: 8px 0 0px;
}
.centerNewsCon{
  margin-top:10px;
  padding: 0 10px;
  width:100%;
  height:55px;
  background:url("/imgs/blikunnewsbg.png") no-repeat;
  background-size:100% 55px;
  position: relative;
}
.centerNewsCon .centerNewsContitle{
  width: 50%;
  height: 24px;
  line-height: 22px;
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
}

.centerNewsCon .ellipsisBox{
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
  margin-top: 5px;
}
.centerNewsCon .blikunnewsicon{
  position: absolute;
  right: 20px;
  top: 15px;
  border: 1px solid rgba(0,253,253,1);
  border-radius: 2px;
  font-size: 14px;
  color: #00FDFD;
  font-weight: 400;
  padding: 2px 16px;
}
#publishMain1{
  width: 100%;
}

</style>
